import { Row, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import OfferAdditionalContent from './OfferAdditionalContent'
import OrderedPartsTable from './OrderedPartsTable'
import { CheckCircle, TimesCircle } from '$components/Icons'
import { useUser } from '$context/user'
import PropTypes from 'prop-types'

const ExpandedRow = ({
  orderPartsList,
  orderPartFormData,
  resetOrderPartFormData,
  orderPartListStatus,
  editable,
  showProviderOffers,
  showRejectedProviderOffers,
  showOfferTerms,
  additionalOrderPartsTableColumns = [],
}) => {
  const { t } = useTranslation()
  const { Text } = Typography
  const { isServiceUser } = useUser()

  return (
    <>
      {isServiceUser && (
        <>
          <h4 style={{ padding: '15px 0 0 0' }}>
            {t('service.order_part.additional_information')}
          </h4>
          <div style={{ display: 'flex', gap: '4px', margin: '12px 0' }}>
            {[
              {
                label: t('service.order_part.allow_partial_delivery'),
                value:
                  (orderPartsList.main_order?.allow_partial_delivery ??
                    false) ||
                  orderPartsList.list_of_suborders.length > 1,
              },
              {
                label: t('service.order_part.allow_subcontractors'),
                value: orderPartsList.main_order?.allow_subcontractors ?? false,
              },
              {
                label: t('service.order_part.allow_other_suppliers'),
                value:
                  orderPartsList.main_order?.allow_other_suppliers ?? false,
              },
            ].map(({ label, value }) => (
              <div
                key={label}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                }}
              >
                <Text type="secondary" style={{ fontSize: '12px' }}>
                  {label}:
                </Text>
                <Text
                  type={value ? 'success' : 'danger'}
                  style={{ fontSize: '12px', fontWeight: 500 }}
                >
                  {value ? <CheckCircle /> : <TimesCircle />}
                </Text>
              </div>
            ))}
          </div>
        </>
      )}
      <Row>
        <h4 style={{ padding: '15px 0 0 0' }}>
          {t('my_orders.ordered_parts')}
        </h4>
        <OrderedPartsTable
          orderPartsList={orderPartsList}
          orderPartFormData={orderPartFormData}
          resetOrderPartFormData={resetOrderPartFormData}
          orderPartListStatus={orderPartListStatus}
          editable={editable}
          showProviderOffers={showProviderOffers}
          showRejectedProviderOffers={showRejectedProviderOffers}
          showOfferTerms={showOfferTerms}
          additionalColumns={additionalOrderPartsTableColumns}
        />
        <div style={{ padding: '0 15px', width: '100%' }}>
          <OfferAdditionalContent
            orderPartsList={orderPartsList}
            editable={false}
          />
        </div>
      </Row>
    </>
  )
}

ExpandedRow.propTypes = {
  orderPartsList: PropTypes.shape({
    main_order: PropTypes.shape({
      desired_delivery_date: PropTypes.string,
      allow_partial_delivery: PropTypes.bool,
      allow_other_suppliers: PropTypes.bool,
      allow_subcontractors: PropTypes.bool,
    }).isRequired,
    list_of_suborders: PropTypes.array,
  }),
}

export default ExpandedRow
